import { combineReducers } from 'redux';

import {
  setEditingScript,
  setSavingScript,
  setSavedScript,
} from '../actions';
import { AutoSaveState, ScenesAction } from '../types';
import { Reducer } from '../../../types';

type ReducerOf<T extends keyof AutoSaveState> = Reducer<AutoSaveState, ScenesAction, T>;

const editing: ReducerOf<'editing'> = (state = true, action) => {
  switch (action.type) {
    case setEditingScript.type:
      return action.payload;

    default:
      return state;
  }
};

const saving: ReducerOf<'saving'> = (state = false, action) => {
  switch (action.type) {
    case setSavingScript.type:
      return action.payload;

    default:
      return state;
  }
};

const saved: ReducerOf<'saved'> = (state = false, action) => {
  switch (action.type) {
    case setSavedScript.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers<AutoSaveState>({
  editing,
  saving,
  saved,
});
